import { ChangeDetectorRef, DestroyRef, inject, Injectable } from '@angular/core';

import { Collection } from './collection.model';
import { IFBCollectionService } from '@app/models/collection';
import { NgOnDestroy } from '@app/shared/services/ng-on-destroy.service';

/**
 * Creates a Collection bound to the current injection context (e.g. a component field initializer).
 */
export function injectCollection<Item, Counts>(
  service: IFBCollectionService<Item>,
  resources: { [prop: string]: any[] } = {}
): Collection<Item, Counts> {
  return new Collection<Item, Counts>(service, inject(DestroyRef), resources, inject(ChangeDetectorRef));
}

@Injectable()
export class CollectionService {
  collection<Item, Counts>(
    service: IFBCollectionService<Item>,
    destroy: NgOnDestroy | DestroyRef,
    resources?: any,
    cdr?: ChangeDetectorRef
  ): Collection<Item, Counts> {
    return new Collection<Item, Counts>(service, destroy, resources, cdr);
  }
}
